import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { track } from "../lib/track";

export function TrackPageviews() {
  const { pathname } = useLocation();
  useEffect(() => {
    const m = pathname.match(/^\/vettura\/(.+)$/);
    track("pageview", m ? { vehicle_id: m[1] } : {});
  }, [pathname]);
  return null;
}
